import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import debounce from 'lodash.debounce';
import { Controller, useFormContext } from 'react-hook-form';
import useFetchModels from '../../../../hooks/models/useFetchModels';
import { setModelsSearchAction } from '../../../../redux/actions/modelsActions';
import SearchableSelect from './../SearchableSelect';

const ModelSelect = ({ disabled }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { models, brandId } = useFetchModels({ unpaged: true });
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = models.map((model) => {
    return {
      label: model.name,
      value: model,
    };
  });

  const handleInputChange = (newValue) => {
    debounced(newValue);
  };

  const debounced = debounce((newValue) => {
    dispatch(setModelsSearchAction(newValue));
  }, 300);

  return (
    <div>
      <label className="input-label">Модель</label>
      <Controller
        name="model"
        rules={{ required: "Це поле є обов'язковим" }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SearchableSelect
            disabled={disabled || !brandId}
            value={value ? { label: value.name, value: value } : null}
            options={selectOptions}
            isMobileView={isMobileView}
            placeholder={'Виберіть модель'}
            handleInputChange={handleInputChange}
            onChange={(selectedValue) => {
              onChange(selectedValue);
            }}
          />
        )}
      />
      {errors['model'] && <span className="text-xs text-contrast1 mt-1">{errors['model'].message}</span>}
    </div>
  );
};
export default ModelSelect;
